"use client";

import { usePathname } from "next/navigation";
import NextBreadcrumb from "@/components/ui/Breadcrumbs/NextBreadcrumb";
import ValorAgregadoTabs, {
  getActiveValorAgregadoTab,
  isValorAgregadoTabRoot,
} from "@/components/soluciones/ValorAgregadoTabs";
import { BreadcrumbList } from "@/@types/Breadcrumbs";

export default function ValorAgregadoCatTabsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const showTabsChrome = isValorAgregadoTabRoot(pathname);
  const activeTab = getActiveValorAgregadoTab(pathname);

  if (!showTabsChrome) {
    return <>{children}</>;
  }

  const breadcrumbMap: BreadcrumbList = [
    { slug: "soluciones", name: "Soluciones" },
    { slug: "valor-agregado-cat", name: "Valor Agregado Cat" },
  ];

  return (
    <>
      <section className=" bg-white ">
        <header className="md:container pt-6 lg:pt-10 px-4">
          <div className="pt-5">
            <NextBreadcrumb
              titleCustom={activeTab && "customLabel" in activeTab ? activeTab.customLabel : activeTab?.label}
              breadcrumbMap={breadcrumbMap}
              isCustomPath={true}
              showTitle={false}
            />
          </div>
        </header>
      </section>
      <section className="bg-silver">
        
        <div className="md:container md:mt-3 md:px4">
          <ValorAgregadoTabs />
        </div>

        <div className="container  pb-28 ">
            <div className="bg-white">{children}</div>
        </div>
      </section>
    </>
  );
}
